import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import findPreviewForSelectedBundleProduct from 'utils/bundles/findPreviewForSelectedBundleProduct';
import getBundleGroups from '../selector/getBundleGroups';
import getSelectedBundleProducts from '../selector/getSelectedBundleProducts';
import { resetForcedProductPreviewsAction, setForcedProductPreviewAction } from '../slice';

const forceProductPreviewFromBundleProductsOperation =
  () => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const selectedBundleProducts = getSelectedBundleProducts(store);
    const bundleGroups = getBundleGroups(store);
    dispatch(resetForcedProductPreviewsAction());

    selectedBundleProducts.forEach((sp) => {
      if (sp.productId === 0) return;
      const preview = findPreviewForSelectedBundleProduct(bundleGroups, sp);
      if (preview) {
        // force preview
        dispatch(
          setForcedProductPreviewAction({
            index: 0,
            preview,
          }),
        );
      }
    });
  };

export default forceProductPreviewFromBundleProductsOperation;
